import React, { useRef } from "react"
import { Link } from "gatsby"
import Img from "gatsby-image"

import useHoverBloom from "./bloom"

export default props => {
  const { thumbnail, title } = props.node.frontmatter
  const isVideo = thumbnail.extension === "mp4"
  const colorVideo = useRef(null)

  // Video thumbnails: keep the colour copy paused until it is needed, and line
  // it up with the greyscale copy when the bloom starts.
  const { ref, handlers } = useHoverBloom({
    onOpen: () => {
      const color = colorVideo.current
      const base = ref.current && ref.current.querySelector(".bloom-base video")
      if (!color) return
      if (base) color.currentTime = base.currentTime
      const played = color.play()
      if (played && played.catch) played.catch(() => {})
    },
    onClosed: () => {
      if (colorVideo.current) colorVideo.current.pause()
    },
  })

  return (
    <article
      ref={ref}
      {...handlers}
      className={`post-card ${props.count % 3 === 0 && `post-card-jumbo`} ${
        props.postClass
      } ${thumbnail ? `with-image` : `no-image`}`}
    >
      <Link to={props.node.fields.slug} className="post-card-link">
        <div className="post-card-content" data-ext={thumbnail.extension}>
          <h2 className="post-card-title">{title || props.node.fields.slug}</h2>
        </div>
      </Link>
      <div className="post-card-bg">
        <div className="bloom-base">
          {isVideo ? (
            <div
              className="video-container"
              dangerouslySetInnerHTML={{
                __html: `<video autoplay playsinline loop muted><source src=${thumbnail.publicURL} type="video/mp4" /></video>`,
              }}
            ></div>
          ) : (
            <Img
              className="kg-image"
              fluid={thumbnail.childImageSharp.fluid}
              alt={title}
            />
          )}
        </div>
        <div className="bloom-color" aria-hidden="true">
          {isVideo ? (
            <div className="video-container">
              <video ref={colorVideo} playsInline loop muted preload="auto">
                <source src={thumbnail.publicURL} type="video/mp4" />
              </video>
            </div>
          ) : (
            <Img className="kg-image" fluid={thumbnail.childImageSharp.fluid} />
          )}
        </div>
      </div>
    </article>
  )
}
